<template>
  <div class="wg-row">
    <!-- Modal to add a file -->
    <wg-modal
      simple
      v-if="showAddFileModal"
      @closeModal="showAddFileModal = false"
    >
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, "Add file", "Nuovo file") }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <anm22-file-uploader
          :uploadUrl="'contact/contact-file-upload?idContact=' + this.contactId"
          :allowedExtensions="[
            'xls',
            'xlsx',
            'pdf',
            'doc',
            'docx',
            'ps',
            'ai',
            'eps',
            'jpg',
            'jpeg',
            'png',
            'svg',
            'dwg',
          ]"
          :onSuccess="addFile"
        ></anm22-file-uploader>
      </div>
    </wg-modal>
    <!-- Modal to delete a file -->
    <wg-modal
      simple
      v-if="showDeleteFileModal"
      @closeModal="showDeleteFileModal = false"
    >
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, "Delete file?", "Cancellare file?") }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input
            type="button"
            class="small com-anm22-button-red"
            :value="$anm22.strLang(lang, 'OK', 'OK')"
            @click="removeFile"
          />
          <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
          <input
            type="button"
            class="small"
            :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
            @click="closeDeleteFileModal()"
          />
        </div>
      </div>
    </wg-modal>
    <div class="add-file wg-col wg-sm-12" @click="showAddFileModal = true">
      {{ $anm22.strLang(lang, "+ Add file", "+ Nuovo file") }}
    </div>
    <div v-if="files.length == 0" class="com-anm22-app-text-l no-docs-label">
      {{ $anm22.strLang(lang, "No documents", "Nessun documento") }}
    </div>
    <div class="files-container">
      <div
        v-for="(file, i) in files.slice(0).sort((a, b) => b.ts - a.ts)"
        :key="'upload-' + i"
        class="wg-row file-item"
        @click="openFile(file)"
      >
        <!-- miniatura se possibile -->
        <img
          class="com-anm22-app-img-fixed-height-l file-ic"
          :src="getFileSrc(file.url)"
        />
        <!-- nome file -->
        <div class="com-anm22-app-text-l label">
          {{ getFileName(file.url) }}
        </div>
        <!-- delete -->
        <img
          class="com-anm22-app-img-fixed-height-m delete-btn"
          :src="$anm22.icons.getWorldIcon('deleteBin')"
          @click.stop="openDeleteFileModal(file.idWorldFile)"
        />
      </div>
    </div>
    <div class="vertical-height-div" style="height:47px;"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WGList from "../../../../world/spa/components/WGList.vue";
import Anm22FileUploader from "../../../../world/spa/components/Anm22FileUploader.vue";

export default {
  components: {
    WGList,
    Anm22FileUploader,
  },
  props: {
    contactId: [String, Number],
  },
  data() {
    return {
      loading: false,
      selectedFileToDelete: null,
      showAddFileModal: false,
      showDeleteFileModal: false,
      files: [],
    };
  },
  computed: {
    ...mapState({
      windowWidth: (state) => state.windowWidth,
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      workSelected: (state) => state.workSelected,
    }),
    licenses() {
      if (this.contact.workOwner) {
        return [
          this.$store.getters["licenses/getByWork"](this.contact.workOwner),
        ];
      } else {
        return [];
      }
    },
    userPermission() {
      return this.$store.getters["employments/getPermByWork"](
        this.contact.workOwner
      );
    },
    checkLicense() {
      if (this.licenses.length > 0) {
        const license = this.licenses[0];
        if (
          license &&
          license.config.apps &&
          license.config.apps.tasks &&
          license.config.apps.tasks.enabled == true
        ) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    contact() {
      return this.$store.getters["contacts/get"](this.contactId);
    },
  },
  methods: {
    contactFiles() {
      return this.$store.getters["files/getByContact"](this.contactId).filter(
        (file) => file.deleted != 1
      );
    },
    loadContactFiles() {
      this.$http
        .get("contact/files?idContact=" + this.contactId)
        .then((response) => {
          if (response.data) {
            this.files = response.data.files.filter(
              (file) => file.deleted != 1
            );
            this.$store.dispatch("files/update", {
              vlf: this.$vlf("files"),
              objs: [response.data.files],
            });
          }
        });
    },
    getFileName(url) {
      return url.split("/").reverse()[0];
    },
    getFileSrc(url) {
      if (/\.(jpe?g|png|gif|svg)$/i.test(url)) {
        return this.$anm22.getImagePath(url);
      } else {
        var re = /(?:\.([^.]+))?$/;
        var ext = re.exec(url)[1];
        if (ext) {
          ext = ext.toLowerCase();
        }
        if (
          ext == "pdf" ||
          ext == "ai" ||
          ext == "cad" ||
          ext == "doc" ||
          ext == "docx" ||
          ext == "eps" ||
          ext == "html" ||
          ext == "js" ||
          ext == "ppt" ||
          ext == "pptx" ||
          ext == "txt" ||
          ext == "xls" ||
          ext == "xlsx" ||
          ext == "xml" ||
          ext == "zip"
        ) {
          return (
            "https://www.anm22.it/app/tasks/utilities/img/file/" + ext + ".svg"
          );
        } else {
          return this.$anm22.icons.getWorldIcon("fileDefault");
        }
      }
    },
    addFile(data) {
      if (data.file) {
        this.loadContactFiles();
        this.showAddFileModal = false;
      }
    },
    openDeleteFileModal(fileId) {
      this.selectedFileToDelete = fileId;
      this.showDeleteFileModal = true;
    },
    closeDeleteFileModal() {
      this.selectedFileToDelete = null;
      this.showDeleteFileModal = false;
    },
    removeFile() {
      this.$http
        .post(
          "contact/delete-file?idContact=" +
            this.contactId +
            "&fileId=" +
            this.selectedFileToDelete
        )
        .then((response) => {
          if (response.data) {
            this.loadContactFiles();
            this.selectedFileToDelete = null;
            this.showDeleteFileModal = false;
          }
        });
    },
    openFile(file) {
      window.open(this.$anm22.getImagePath(file.url), "_blank");
    },
  },
  created() {
    this.files = this.contactFiles();
  },
};
</script>

<style lang="scss" scoped>
.add-file {
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  margin: 0 16px 16px 16px;
}
.no-docs-label {
  padding: 0 16px 16px 16px;
}
.files-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .file-item {
    display: flex;
    width: 300px;
    border-radius: 12px;
    padding: 12px 16px;
    background-color: #eee;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    &:hover {
      background-color: #ddd;
    }

    .file-ic {
      width: 24px;
      height: 24px;
      margin-right: 16px;
      object-fit: contain;
      object-position: center;
    }

    .label {
      font-size: 14px;
      overflow: hidden;
      flex-wrap: wrap;
      word-wrap: break-word;
      flex-grow: 1;
      width: calc(100% - 76px);
      flex: 1;
    }

    .delete-btn {
      margin: 0;
      width: 20px;
      height: 20px;
      margin-left: 16px;
      opacity: 0.8;
    }
  }
}
</style>
